import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import ActionItem from "components/ActionItem";
import LegacyIcon from "components/icons/legacy-icon";
import { DropDownList, DropDownListItem } from "components/Shared/dropdown";
import useOutsideClickHider from "../helpers/OutsideClickHider";

const HeaderElement = styled.div`
  cursor: pointer;
  font-weight: 600;
  padding: 0.5625rem;
  // margin: 0 1.0625rem;
  transition: ${({ theme }) => theme.opacityTransition};
`;

const HeadText = styled.div`
  display: none;

  ${({ theme }) => theme.mq.lg`
    display: block;
    font-size: ${theme.fontSize(2)};
    line-height: 125.3%;
    display: flex;
    align-items: center;
  `}
`;

const TextWrapper = styled.div`
  font-size: 0.875rem;
  display: flex;
  align-items: center;

  > svg {
    margin: 0 0 0.1875rem 0.5rem;
    transform: rotate(180deg);
    transition: transform 0.2s ease-out;
  }

  &.hideList > svg {
    transform: rotate(360deg);
    margin-bottom: 0.375rem;
  }
`;

const List = (props) => {
  const { hideList, listItems, right } = props;
  return (
    <DropDownList hideList={hideList} right={right}>
      {listItems.map((item) => {
        return (
          <DropDownListItem key={item.id}>
            <ActionItem fontSize="0.875rem" {...item} />
          </DropDownListItem>
        );
      })}
    </DropDownList>
  );
};

List.propTypes = {
  hideList: PropTypes.bool,
  listItems: PropTypes.arrayOf(PropTypes.object),
  right: PropTypes.string,
};

List.defaultProps = {
  hideList: true,
  listItems: [],
  right: "23.75rem",
};

export default function NavigationDropdown(props) {
  const [hideList, setHideList] = useState(true);
  const ListEl = React.useRef(null);
  const { listItems, title, right } = props;
  useOutsideClickHider(ListEl, setHideList);

  return (
    <HeadText ref={ListEl}>
      <HeaderElement onClick={() => setHideList(!hideList)}>
        <TextWrapper className={hideList ? "hideList" : ""}>
          {title} <LegacyIcon name="chevron-20" color="#192617" />
        </TextWrapper>
      </HeaderElement>
      <List listItems={listItems} hideList={hideList} right={right} />
    </HeadText>
  );
}

NavigationDropdown.propTypes = {
  title: PropTypes.string,
  listItems: PropTypes.arrayOf(PropTypes.object),
  right: PropTypes.string,
};

NavigationDropdown.defaultProps = {
  title: "LOG IN / SIGN UP",
  listItems: [],
  right: "23.75rem",
};
